export default __webpack_public_path__ + "static/media/115.72c1fe21.jpg";